<template>
  <PageSection disable-sticky-margin :title="$t('global.assets')">
    <div class="flex flex-col gap-4">
      <div class="flex items-end gap-3">
        <div class="flex-1">
          <BaseSelectMultiple
            v-if="metadata.type"
            :placeholder="$t('global.filter')"
            :options="metadata.type"
            name="type"
            label=""
            @setSelected="selectChange"
          />
        </div>
        <div class="flex flex-1 justify-end">
          <BaseButton
            color="primary"
            icon="plus"
            v-if="editionMode && $can('manage_content')"
            @click="redirectToForm"
            :title="$t('button.add_new_f', { var: $t('global.asset') })"
          />
        </div>
      </div>

      <div class="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        <template v-for="asset in filteredAssetsList">
          <div
            class="rounded-md border border-gray-300 p-5"
            :class="editionClass"
          >
            <div class="flex">
              <div class="flex-1">
                <h3 class="text-xl font-medium">
                  <router-link
                    :to="{
                      name: 'settings_edit_asset_route',
                      params: { id: asset.id }
                    }"
                  >
                    {{ asset.name }}
                  </router-link>
                </h3>
                <div class="my-4">
                  <BaseLabel :content="mAssetType(asset.type)" />
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </PageSection>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ImplantationAssetIndexComponent',
  props: {
    assets: {
      type: Array,
      default: []
    },
    implantationId: {
      type: Number,
      required: true
    },
    editionMode: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  data() {
    return {
      focusAsset: '',
      filters: []
    }
  },
  computed: {
    ...mapGetters({ metadata: 'asset/getAssetMetadata' }),
    filteredAssetsList() {
      let tempAssets = this.assets
      if (this.filters.length !== 0) {
        tempAssets = tempAssets.filter((asset) => {
          return this.filters.includes(asset.type)
        })
      }
      return tempAssets
    }
  },
  methods: {
    ...mapActions({
      deleteAssetById: 'asset/deleteAssetById',
      undoDeleteAssetById: 'asset/undoDeleteAssetById'
    }),
    redirectToForm() {
      this.$router.push({
        name: 'settings_create_asset_route',
        params: { id: this.implantationId }
      })
    },
    selectChange({ attribute, value }) {
      this.filters = value.map((el) => el.id)
      this.filteredAssetsList = this.filteredAssetsList.filter((el) =>
        this.filters.includes(el.type)
      )
    },
    mAssetType(type) {
      let item = this.metadata.type
        ? this.metadata.type.find((item) => item.id === type)
        : null
      return item ? item.name : ''
    },
    deleteAsset(id) {
      this.deleteAssetById({
        id: id
      }).then(() => {
        this.$h.toastAction(
          'delete',
          this.$t('toasts.deleted_f', { var: this.$t('attributes.asset') }),
          null,
          [
            {
              title: this.$t('button.cancel'),
              class: 'text-red-700',
              action: () => this.undoDeleteAsset(id)
            }
          ]
        )
      })
    },
    undoDeleteAsset(id) {
      this.undoDeleteAssetById({
        id: id
      }).then(() => {
        this.$h.toastSuccess(
          this.$t('toasts.reseted_f', { var: this.$t('attributes.asset') })
        )
      })
    }
  }
}
</script>
